import React, { useEffect, useMemo, useState } from "react";
import Select from 'react-select';
import moment from "moment";
import swal from "sweetalert2";
import MatchPlayList from "./matchPlayList";
import { useHistory } from "react-router-dom";
import DEFAULT_USER_PHOTO from '../../assets/images/matchPlay_DefaultUserIcon.png';
import VS_IMAGE from '../../assets/images/matchPlay_VS.png';

import { getMatchPlayDraw, postMatchPlayDraw, refreshMatchPlayHandicap,} from "../api/matchPlayAPI";

const MatchPlayDraw = (props) => {

    // const [pageData, setPageData] = useState({});
    //#region States
    const [refetchData, setRefetchData]  = useState(false);
    const [mMaster, setMMaster] = useState(null);
    const [matchPlayID, setMatchPlayID] = useState();
    const history = useHistory();
    const [rounds, setRounds] = useState([]);
    const [registeredPlayers, setRegisteredPlayers] = useState([]);
    const [selectedRound, setSelectedRound] = useState({round: 1, roundName: "Round 1"});
    // const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [round1Matches, setRound1Matches] = useState([]);
    const [drawRounds, setDrawRounds] = useState([]);
    const [totalBye, setTotalBye] = useState(0);
    const [usedBye, setUsedBye] = useState(0);
    const [typeText, setTypeText] = useState("Player");
    
    const [matchPlay, setMatchPlay] = useState({});
    const [matchPlayPlayers, setMatchPlayPlayers] = useState([]);
    const [matchPlayPlayersVs, setMatchPlayPlayersVs] = useState([]);
    const [action, setAction] = useState({});
    const [isFinalWinnerDeclared, setIsFinalWinnerdeclared] = useState(false);
    const [isWinnerdeclared, setIsWinnerdeclared] = useState(false);
    //#endregion

    const selectedPlayerIds = useMemo(() => {
        const ids = [];

        round1Matches?.forEach(match => {
            if (match.lhsPlayer && match.lhsPlayer !== -1) {
                ids.push(Number(match.lhsPlayer));
            }

            if (match.rhsPlayer && match.rhsPlayer !== -1) {
                ids.push(Number(match.rhsPlayer));
            }
        });

        return ids;
    }, [round1Matches]);
    
    // demo
//     useEffect(() => {
//     console.log("State Changed =>", {
//         "mMaster":mMaster,
//         // "pageData":pageData,
//         "rounds":rounds,
//         "registeredPlayers":registeredPlayers,
//         "selectedRound":selectedRound,
//         // "selectedPlayers":selectedPlayers,
//         "round1Matches":round1Matches,
//         "drawRounds":drawRounds,
//         "totalBye":totalBye,
//         "usedBye": usedBye,
//         "matchPlay": matchPlay,
//         "matchPlayPlayers": matchPlayPlayers,
//         "matchPlayPlayersVs": matchPlayPlayersVs,
//         "action": action,
//         "isFinalWinnerDeclared": isFinalWinnerDeclared,
//         "isWinnerDeclared": isWinnerdeclared,
//         "typeText": typeText,
//         "selectedPlayerIds": selectedPlayerIds
//     });
// }, [ mMaster, rounds, registeredPlayers, selectedRound, round1Matches, drawRounds, totalBye, usedBye, matchPlay, matchPlayPlayers, matchPlayPlayersVs, action, isFinalWinnerDeclared, isWinnerdeclared, typeText]);

    //#region Effects
    useEffect(() => {
        props.title("Match Play Draw", "matchplay-draw");
        // Opened from Quick Action as /matchplay-draw/:id → open that match play
        const mID = history.location.pathname.split('/').find(p => !isNaN(p) && p !== '');
        setMatchPlayID(mID);
    }, []);

    const closeDrawer = () =>{
        // window.removeCkeditor("editorContent");
        Config.Core.CloseDrawer();
    }

    // useEffect(() => {
    //     console.log("Selected Round changed: ", selectedRound);
    // }, [selectedRound]);
    //#endregion

    //#region Helpers
    // const type = useMemo(() => {
    //     return pageData?.MatchPlay?.Type || "Singles";
    // }, [pageData]);
    // const typeText = useMemo(() => {
    //     return type === "Singles" ? "Player" : "Team";
    // }, [type]);
    //#endregion

    //#region API Calls

    const fetchMatchPlayDraw = async (matchPlayId) => {
        try {
            swal.fire({
                titleText: "Loading",
                text: "Please Wait...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                onOpen: () => swal.showLoading(),
            });
            const res = await getMatchPlayDraw(matchPlayId);
            swal.close();
            if (!res) return;
            // change demo_rounds to res.MatchPlayRound when API is ready. This is just for testing the round tab rendering and selection.
            const updatedRounds = res.MatchPlayRound.map((round, index) => {
                let roundName = `Round ${round.Round}`;
                const totalRounds = res.MatchPlayRound.length;
                if (index === totalRounds - 3) {
                    roundName = totalRounds > 5 ? "Quarters" : "Quarter Final";
                } else if (index === totalRounds - 2) {
                    roundName = totalRounds > 5 ? "Semis" : "Semi Final";
                } else if (index === totalRounds - 1) {
                    roundName = "Final";
                }
                // Returns a new object with the altered data included
                return { ...round, roundName };
            });
            
            // setPageData(res);
            setMatchPlay(res?.MatchPlay || {});
            setTypeText(res?.MatchPlay?.Type === "Doubles" ? "Team" : "Player");
            setMatchPlayPlayers(res?.MatchPlayPlayers || []);
            setMatchPlayPlayersVs(res?.MatchPlayPlayersVs || []);
            setRegisteredPlayers(res?.MatchPlayRegister || []);
            setRounds(updatedRounds); // testing
            setSelectedRound({ round: updatedRounds[0]?.Round, roundName: updatedRounds[0]?.roundName });
            setIsFinalWinnerdeclared(res?.IsFinalWinnerDeclared || false);
            setIsFinalWinnerdeclared(res?.IsFinalWinnerDeclared || false);
            initializeRounds(res);
            
            if (res?.action == "x") {
                // closeDrawer();
                // onReset();
                swal.fire({
                    icon: "warning",
                    buttonsStyling: false,
                    showConfirmButton: false,
                    titleText: 'Oops..',
                    text: 'Match play deadline not entered, kindly create deadline before creating draw.',
                    timer: 2000,
                })
                return;
            } else {
                // loadData(res)
            }
            setAction(res?.action || '');// check is this needed or not ??
        } catch (err) {
            swal.fire({icon: "error",titleText: err.message});
        }
    };

    //#endregion
    //#region Initialize Draw
    const initializeRounds = (data) => {
        const players = data.MatchPlayRegister || [];
        let total = players.length;
        let goodTotal = 1;
        while (goodTotal < total) {
            goodTotal *= 2;
        }
        const byeCount = goodTotal - total;
        setTotalBye(byeCount);

        let matchPlayerPlayerVSList = [];
        if (data?.MatchPlayPlayersVs) {
            matchPlayerPlayerVSList = data?.MatchPlayPlayersVs;
        }

        const totalMatches = (total + byeCount) / 2;

        if (matchPlayerPlayerVSList?.length === 0) {

                let round1Matches = [];

                for (let i = 0; i < totalMatches; i++) {
                    round1Matches.push({
                        matchNo: i + 1,
                        groupNo: Math.floor(i / 2) + 1,
                        lhsPlayer: "",
                        rhsPlayer: "",
                    });
                }

                setRound1Matches(round1Matches);

                // Generate remaining rounds
                let otherRounds = [];
                let previousMatchCount = totalMatches;

                (data.MatchPlayRound || []).forEach((round) => {

                    if (round.Round === 1) return;

                    const currentMatchCount = previousMatchCount / 2;

                    let matches = [];

                    for (let i = 0; i < currentMatchCount; i++) {
                        matches.push({
                            matchNo: i + 1,
                            groupNo: Math.floor(i / 2) + 1,
                            lhsPlayer: "",
                            rhsPlayer: "",
                        });
                    }

                    otherRounds.push({
                        round: round.Round,
                        matches,
                    });

                    previousMatchCount = currentMatchCount;
                });

                setDrawRounds(otherRounds);
            }else {
            // helper to resolve lhs/rhs from a VS record
            const resolvePlayers = (match) => {
                let lhsPlayer, rhsPlayer;
                if (data?.MatchPlay?.Type === "Singles") {
                    lhsPlayer = players.find((p) => p.User1ID === match.User1ID);
                    rhsPlayer = players.find((p) => p.User1ID === match.User2ID);
                }
                if (data?.MatchPlay?.Type === "Doubles") {
                    lhsPlayer = players.find((p) => p.User1ID === match.User1ID);
                    rhsPlayer = players.find((p) => p.User1ID === match.User3ID);
                }
                return { lhsPlayer, rhsPlayer };
            };

            // ── Round 1 ──────────────────────────────────────────────
            const firstRoundID = data?.MatchPlayRound?.find(x => x.Round === 1)?.ID;
            const round1VS = matchPlayerPlayerVSList.filter(
                (i) => i.MatchPlayRoundID === firstRoundID
            );

            let round1MatchList = [];
            round1VS.forEach((match) => {
                const { lhsPlayer, rhsPlayer } = resolvePlayers(match);
                round1MatchList.push({
                    roundID:   match.MatchPlayRoundID,
                    matchNo:   match.MatchIndex,
                    groupNo:   match.GroupIndex,
                    lhsPlayer: lhsPlayer?.ID ?? "",
                    rhsPlayer: rhsPlayer?.ID ?? -1,
                });
            });

            setRound1Matches(round1MatchList);

            setUsedBye((prev) => {
                let bye = prev;
                round1MatchList.forEach((match) => {
                    if (match.lhsPlayer === -1 || match.rhsPlayer === -1) {
                        bye++;
                    }
                });
                return bye;
            });

            // ── Round 2+ ─────────────────────────────────────────────
            let otherRounds = [];
            (data.MatchPlayRound || []).forEach((round) => {
                if (round.Round === 1) return;

                // get VS records for this round from the shared data
                const roundVS = matchPlayerPlayerVSList.filter(
                    (i) => i.MatchPlayRoundID === round.ID
                );

                let matches = [];

                if (roundVS.length > 0) {
                    // populate from actual VS data
                    roundVS.forEach((match) => {
                        const { lhsPlayer, rhsPlayer } = resolvePlayers(match);
                        matches.push({
                            roundID:   match.MatchPlayRoundID,
                            matchNo:   match.MatchIndex,
                            groupNo:   match.GroupIndex,
                            lhsPlayer: lhsPlayer?.ID ?? "",
                            rhsPlayer: rhsPlayer?.ID ?? -1,
                        });
                    });
                } else {
                    // fallback: empty slots calculated from previous round count
                    const previousMatchCount =
                        round.Round === 2
                            ? totalMatches
                            : otherRounds[otherRounds.length - 1]?.matches?.length || 0;
                    const currentMatchCount = previousMatchCount / 2;

                    for (let i = 0; i < currentMatchCount; i++) {
                        matches.push({
                            matchNo:   i + 1,
                            groupNo:   Math.floor(i / 2) + 1,
                            lhsPlayer: "",
                            rhsPlayer: "",
                        });
                    }
                }

                otherRounds.push({
                    round:   round.Round,
                    matches,
                });
            });

            setDrawRounds(otherRounds);
        }
    };
    //#endregion
    //#region Handlers
    const onSelectHandler = async (master) => {
        if (!master) return;
        setMMaster(master);
        await fetchMatchPlayDraw(master.ID);
    };

    const onReset = () => {
        setMMaster(null);
        // setPageData({});
        setRounds([]);
        setRegisteredPlayers([]);
        setRound1Matches([]);
        setDrawRounds([]);
        // setSelectedPlayers([]);
        setUsedBye(0);
        setTotalBye(0);
        setSelectedRound({ round: 1, roundName: "Round 1" });
        setMatchPlay({});
        setMatchPlayPlayers([]);
        setMatchPlayPlayersVs([]);
        setAction({});
        setIsFinalWinnerdeclared(false);
        setIsWinnerdeclared(false);
    };

    const getPlayerName = (player) => {
        if (!player) return "";
        if (matchPlay?.Type === "Singles") {
            return player.User1Name;
        }
        return `${player.User1Name} | ${player.User2Name}`;
    };

    const getPlayerImage1 = (player) => {
        if (!player?.User1Photo) {
            return DEFAULT_USER_PHOTO;
        }
        return player.User1Photo;
    };

    const getPlayerImage2 = (player) => {

        if (!player?.User2Photo) {
            return DEFAULT_USER_PHOTO;
        }

        return player.User2Photo;
    };

    const onChangePlayer = (index, side, value) => {
        const updated = [...round1Matches];
        const oldValue = updated[index][side];
        if (oldValue === -1) setUsedBye(prev => prev - 1);
        updated[index][side] = parseInt(value);
        setRound1Matches(updated);
        // let selected = [];
        // updated.forEach(item => {
        //     if (item.lhsPlayer && item.lhsPlayer !== -1) selected.push(item.lhsPlayer);
        //     if (item.rhsPlayer && item.rhsPlayer !== -1) selected.push(item.rhsPlayer);
        // });
        // setSelectedPlayers(selected);
        if (parseInt(value) === -1) {
            setUsedBye(prev => prev + 1);
        }
    };

    const getAvailablePlayers = (currentPlayerId, includeBye = false) => {
        const players = registeredPlayers.filter(player => {
            // show current selected player
            if (player.ID === currentPlayerId) {
                return true;
            }

            // hide already selected players
            return !selectedPlayerIds.includes(player.ID);
        });

        if (includeBye) {
            return [
                {
                    ID: -1,
                    Name: "BYE",
                },
                ...players,
            ];
        }

        return players;
    };

    const refreshHandicap = async (round) => {
        try {
            swal.fire({
                titleText: "Loading",
                text: "Please Wait...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                onOpen: () => swal.showLoading(),
            });
            await refreshMatchPlayHandicap({
                matchPlayID: matchPlay?.ID,
                round,
            });
            swal.fire({
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 1500,
                animation: false,
                showConfirmButton: false,
                customClass: {
                    popup: "margin-20",
                },
                titleText: "Refresh Handicap updated successfully!",
            });
        } catch (err) {
            swal.fire({
                icon: "error",
                titleText: err.message,
            });
        }
    };

    const saveDraw = async () => {
    try {
        // VALIDATIONS
        if (selectedPlayerIds.length === 0) {
            swal.fire({
                icon: "warning",
                titleText: "Oops..",
                text: "Please select players",
            });
            return;
        }

        if (selectedPlayerIds.length !== registeredPlayers.length) {
            swal.fire({
                icon: "warning",
                titleText: "Oops..",
                text: "Please select all players",
            });
            return;
        }

        if (totalBye !== usedBye) {
            swal.fire({
                icon: "warning",
                titleText: "Oops..",
                text: "BYE mismatched",
            });
            return;
        }

        const duplicatePlayers = selectedPlayerIds.filter(
            (item, index) => selectedPlayerIds.indexOf(item) !== index
        );

        if (duplicatePlayers.length > 0) {
            swal.fire({
                icon: "warning",
                titleText: "Oops..",
                text: "Duplicate player selected",
            });
            return;
        }

        // LOADER
        swal.fire({
            titleText: "Loading",
            text: "Please Wait...",
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            onOpen: () => swal.showLoading(),
        });

        // ROUND ID
        const roundID = rounds.find(i => i.Round === 1)?.ID;

        // MATCH PLAY PLAYER
        const players = [];
        selectedPlayerIds.forEach((playerID) => {
            const player = registeredPlayers.find(i => i.ID === playerID);
            if (!player) return;
            players.push({
                ID: 0,
                MatchPlayRoundID: roundID,
                User1ID: player.User1ID,
                User2ID: player.User2ID == null ? 0 : player.User2ID,
            });
        });

        // MATCH PLAY PLAYER VS
        const playerVs = [];
        const matches = round1Matches.length;
        const groups = matches / 2;
        const matchPerGroup = matches / groups;
        let groupIndex = 0;
        let currentGroup = 1;
        let currentMatch = 0;

        round1Matches.forEach((match, index) => {
            const lhs = registeredPlayers.find(i => i.ID === match.lhsPlayer);
            const rhs = registeredPlayers.find(i => i.ID === match.rhsPlayer);
            currentMatch = index + 1;
            if (groupIndex === matchPerGroup) {
                groupIndex = 1;
                currentGroup++;
            } else {
                groupIndex++;
            }

            // SINGLES
            if (matchPlay?.Type === "Singles") {
                playerVs.push({
                    ID: 0,
                    MatchPlayRoundID: roundID,
                    User1ID: lhs?.User1ID || 0,
                    User2ID: rhs?.User1ID || 0,
                    User3ID: 0,
                    User4ID: 0,
                    User1Handicap: lhs?.User1Handicap || 0,
                    User2Handicap: rhs?.User1Handicap || 0,
                    User3Handicap: 0,
                    User4Handicap: 0,
                    User1TeeBoxID: lhs?.DefaultTeeBox1ID || 0,
                    User2TeeBoxID: rhs?.DefaultTeeBox1ID || 0,
                    User3TeeBoxID: 0,
                    User4TeeBoxID: 0,
                    IsBye: rhs ? "N" : "Y",
                    GroupIndex: currentGroup,
                    MatchIndex: currentMatch,
                    IsCardSubmitted: "N",
                    IsScoreVerified: "N",
                });
            }

            // DOUBLES
            if (matchPlay?.Type === "Doubles") {
                playerVs.push({
                    ID: 0,
                    MatchPlayRoundID: roundID,
                    User1ID: lhs?.User1ID || 0,
                    User2ID: lhs?.User2ID || 0,
                    User3ID: rhs?.User1ID || 0,
                    User4ID: rhs?.User2ID || 0,
                    User1Handicap: lhs?.User1Handicap || 0,
                    User2Handicap: lhs?.User2Handicap || 0,
                    User3Handicap: rhs?.User1Handicap || 0,
                    User4Handicap: rhs?.User2Handicap || 0,
                    User1TeeBoxID: lhs?.DefaultTeeBox1ID || 0,
                    User2TeeBoxID: lhs?.DefaultTeeBox1ID || 0,
                    User3TeeBoxID: rhs?.DefaultTeeBox1ID || 0,
                    User4TeeBoxID: rhs?.DefaultTeeBox1ID || 0,
                    IsBye: rhs ? "N" : "Y",
                    GroupIndex: currentGroup,
                    MatchIndex: currentMatch,
                    IsCardSubmitted: "N",
                    IsScoreVerified: "N",
                });
            }
        });

        // MATCH COUNT
        const matchCount = [];
        rounds.forEach((r) => {
            if (r.Round !== 1) {
                const currentRound = drawRounds.find(
                    d => d.round === r.Round
                );
                matchCount.push({
                    DTO4: r.Round,
                    DTO5: currentRound?.matches?.length || 0,
                });
            }
        });

        const payload = {
            matchPlayID: matchPlay?.ID,
            matchPlayRoundID: roundID,
            matchPlayPlayer: players,
            matchPlayPlayerVs: playerVs,
            matchCount,
        };
        // API CALL
        await postMatchPlayDraw(payload);
        swal.fire({
            icon: "success",
            titleText: "Draw Saved Successfully",
            showConfirmButton: false,
            timer: 1500,
        });

        await fetchMatchPlayDraw(matchPlay?.ID);

    } catch (err) {

        swal.fire({
            icon: "error",
            titleText: err.message || "Something went wrong",
        });
    }
};

    //#endregion

    return (
        <>
            <MatchPlayList
                matchPlayID={matchPlayID}
                setMatchPlayID={setMatchPlayID}
                title={"Match Play Draw"}
                comp={"draw"}
                refetchData={refetchData}
                resetRefetch={() => setRefetchData(false)} 
                onSelectHandler={onSelectHandler}
                resetData={onReset}
            >
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0 ">
                    <div className="kt-container--fluid  kt-grid__item kt-grid__item--fluid">{/* kt-container  */}
                        <div className="kt-portlet kt-portlet--mobile padding-lr20">
                            <div className="kt-portlet__head kt-portlet__head--lg d-block padding-lr0 border-0">
                            {!!matchPlay && (
                                <div className="kt-notification margin-t10 mb-3 bg-lightGrey">
                                    <div className="kt-notification__item d-block">
                                        <div className="row">
                                            {/* LEFT SECTION */}
                                            <div className="col-8">
                                                <div className="kt-user-card-v2">
                                                    <div className="kt-user-card-v2__pic">
                                                        <img
                                                            src={DEFAULT_USER_PHOTO}
                                                            // src={matchPlay?.Icon}
                                                            alt="matchplay-logo"
                                                            style={{
                                                                height: 40,
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="kt-user-card-v2__details">
                                                        <span className="kt-user-card-v2__name text-clip">
                                                            {matchPlay?.Name}
                                                        </span>
                                                        <span className="kt-user-card-v2__desc">
                                                            {matchPlay?.Type} | {matchPlay?.MembershipType}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* START DATE */}
                                            <div className="col-2 d-flex-center">
                                                <div className="kt-user-card-v2 mb-2">
                                                    <div className="kt-user-card-v2__details">
                                                        <span className="kt-user-card-v2__name">
                                                            Start
                                                        </span>
                                                        <span className="kt-user-card-v2__desc">
                                                            {moment(matchPlay?.StartDate).format("DD-MMM-YYYY")}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* END DATE */}
                                            <div className="col-2 d-flex-center">
                                                <div className="kt-user-card-v2 mb-2">
                                                    <div className="kt-user-card-v2__details">
                                                        <span className="kt-user-card-v2__name">
                                                            End
                                                        </span>
                                                        <span className="kt-user-card-v2__desc">
                                                            {moment(matchPlay?.EndDate).format("DD-MMM-YYYY")}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>

                        {!!matchPlay && rounds.length > 0 && (
                            <>
                                {/* ROUND TABS */}
                                <div className={`kt-wizard-v4 wizard-r${rounds.length} data-ktwizard-state="first"`} id="kt_user_add_user">
                                    <div className="kt-wizard-v4__nav">
                                        <div className="kt-wizard-v4__nav-items nav "> 
                                            {rounds.map((round, index) => {
                                                return (
                                                    <div key={round.ID} className={`pnl-round-tab kt-wizard-v4__nav-item nav-item ${(selectedRound.round === round.Round) && "bg-white" } `} onClick={() => setSelectedRound({round: round.Round, roundName: round.roundName})}>
                                                            <div className='kt-wizard-v4__nav-body'>
                                                                <div className={`kt-wizard-v4__nav-number ${(selectedRound.round === round.Round) ? "text-white bg-info" : "text-info"}`}> {round.Round} </div>
                                                                <div className='kt-wizard-v4__nav-label'>
                                                                    <div className={`kt-wizard-v4__nav-label-title ${(selectedRound.round === round.Round) && "text-info"}`}>{round.roundName}</div>
                                                                    <div className='kt-wizard-v4__nav-label-desc'>{moment(round.EndDate).format("DD MMM, YYYY")}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>

                                {/* ROUND 1 */}
                                {selectedRound.round === 1 && (
                                    <div className="kt-portlet kt-portlet--mobile tab-content margin-t10">
                                    <div className="pnl-round" id={`round${selectedRound.round}` }>
                                        <div className="kt-portlet__head">
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">{selectedRound.roundName}</h3>
                                            </div>
                                            <div className="kt-portlet__head-toolbar">
                                                <div className="kt-widget__button margin-r5">
                                                    <span className="btn btn-label-brand btn-sm">
                                                        Total {typeText}s : <b>{" "}{registeredPlayers.length}</b>
                                                    </span>
                                                </div>
                                                <div className="kt-widget__button margin-r5">
                                                    <span className="btn btn-label-warning btn-sm">
                                                        Total BYES :<b>{" "}{totalBye}</b>
                                                    </span>
                                                </div>
                                                <div className="kt-widget__button">
                                                    <span className="btn btn-label-success btn-sm">
                                                        BYES Assigned :<b>{" "}{usedBye}</b>
                                                    </span>
                                                </div>
                                                </div>
                                                
                                                {(!isFinalWinnerDeclared) && (
                                                    <button
                                                        type="button"
                                                        id={`btnRefreshHandicap${selectedRound.round}`}
                                                        name={`btnRefreshHandicap${selectedRound.round}`}
                                                        className="btn btn-success btn-icon-sm text-white d-inline margin-lr0 btn-sm"
                                                        onClick={() =>
                                                            refreshHandicap(1)
                                                        }
                                                    > Refresh Handicap</button>
                                                )}
                                        </div>

                                        <div className="kt-portlet__body">
                                            {round1Matches.map((match, index) => {
                                                const lhsPlayer = registeredPlayers.find( i => i.ID === match.lhsPlayer );
                                                const rhsPlayer = registeredPlayers.find( i => i.ID === match.rhsPlayer );

                                                return (
                                                    <div className="card panel-match margin-b20" key={index} >
                                                        {/* CARD HEADER */}
                                                        <div className="card-header" style={{ height: 36, }} >
                                                            <div className="card-title w-100">
                                                                <div className="row w-100">
                                                                    <div className="col-5">
                                                                        <h6> <strong> Match {match.matchNo} </strong> </h6>
                                                                    </div>
                                                                    <div className="col-2 text-center">
                                                                        <h6>
                                                                            <strong> Group {match.groupNo} </strong>
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* CARD BODY */}
                                                        <div className="card-body" style={{ minHeight: 115, }} >
                                                            <div className="row">
                                                                {/* LHS PLAYER */}
                                                                <div className="col-sm-5">
                                                                    <div className="row">
                                                                        <div className="col-sm-3">
                                                                            <img src={getPlayerImage1(lhsPlayer)} alt="" className="player-image img-responsive img-circle img-user margin-t5" />
                                                                        </div>
                                                                        <div className="col-sm-6">
                                                                            <div className="form-group margin-b0">
                                                                                <label className="col-form-label padding-t0">
                                                                                    {typeText} 1
                                                                                </label>
                                                                                {/* <select className="form-control" value={match.lhsPlayer} onChange={({ target }) => onChangePlayer( index,"lhsPlayer", target.value)}>
                                                                                    <option value="">
                                                                                        Select {typeText}
                                                                                    </option> */}
                                                                                    {/* {registeredPlayers.map(player => (
                                                                                        <option value={player.ID} key={player.ID} >
                                                                                            {getPlayerName(player)}
                                                                                        </option>
                                                                                    ))} */}
                                                                                    {/* {getAvailablePlayers(match.lhsPlayer).map(player => (
                                                                                        <option value={player.ID} key={player.ID}>
                                                                                            {getPlayerName(player)}
                                                                                        </option>
                                                                                    ))}
                                                                                </select> */}
                                                                                <Select
                                                                                    className="width-100p"
                                                                                    placeholder={`Select ${typeText}`}
                                                                                    options={getAvailablePlayers(match.lhsPlayer).map(player => ({
                                                                                        label: getPlayerName(player),
                                                                                        value: player.ID,
                                                                                    }))}
                                                                                    value={
                                                                                        match.lhsPlayer
                                                                                            ? getAvailablePlayers(match.lhsPlayer)
                                                                                                .map(player => ({
                                                                                                    label: getPlayerName(player),
                                                                                                    value: player.ID,
                                                                                                }))
                                                                                                .find(option => option.value === match.lhsPlayer)
                                                                                            : null
                                                                                    }
                                                                                    onChange={(event) =>
                                                                                        onChangePlayer(index, "lhsPlayer", event?.value || "")
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        {typeText === "Doubles" && (
                                                                            <div className="col-sm-3">
                                                                                <img src={getPlayerImage2(lhsPlayer)} alt="" className="player-image img-responsive img-circle img-user margin-t5" />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* VS IMAGE */}
                                                                <div className="col-sm-2 center text-center">
                                                                    <img src={VS_IMAGE} alt="vs" style={{ width: 85, height: 85,}} />
                                                                </div>

                                                                {/* RHS PLAYER */}
                                                                <div className="col-sm-5">
                                                                    <div className="row">
                                                                        <div className="col-sm-3">
                                                                            <img src={getPlayerImage1(rhsPlayer)} alt="" className="player-image img-responsive img-circle img-user margin-t5"/>
                                                                        </div>
                                                                        <div className="col-sm-6">
                                                                            <div className="form-group margin-b0">
                                                                                <label className="col-form-label padding-t0">
                                                                                    {typeText} 2
                                                                                </label>
                                                                                {/* <select className="form-control" value={match.rhsPlayer}
                                                                                    onChange={({ target }) =>
                                                                                        onChangePlayer( index, "rhsPlayer", target.value)
                                                                                    }
                                                                                >
                                                                                    <option value="">
                                                                                        Select {typeText}
                                                                                    </option>
                                                                                    <option value={-1}>
                                                                                        BYE
                                                                                    </option> */}
                                                                                    {/* {registeredPlayers.map(player => (
                                                                                        <option value={player.ID} key={player.ID} >
                                                                                            {getPlayerName(player)}
                                                                                        </option>
                                                                                    ))} */}
                                                                                    {/* {getAvailablePlayers(match.rhsPlayer).map(player => (
                                                                                        <option value={player.ID} key={player.ID}>
                                                                                            {getPlayerName(player)}
                                                                                        </option>
                                                                                    ))}
                                                                                </select> */}
                                                                                <Select
                                                                                    className="width-100p"
                                                                                    placeholder={`Select ${typeText}`}
                                                                                    options={getAvailablePlayers(match.rhsPlayer, true).map(player => ({
                                                                                        label: player.ID === -1 ? "BYE" : getPlayerName(player),
                                                                                        value: player.ID,
                                                                                    }))}
                                                                                    value={
                                                                                        getAvailablePlayers(match.rhsPlayer, true)
                                                                                            .map(player => ({
                                                                                                label: player.ID === -1 ? "BYE" : getPlayerName(player),
                                                                                                value: player.ID,
                                                                                            }))
                                                                                            .find(option => Number(option.value) === Number(match.rhsPlayer))
                                                                                            || null
                                                                                    }
                                                                                    onChange={(event) =>
                                                                                        onChangePlayer(
                                                                                            index,
                                                                                            "rhsPlayer",
                                                                                            event?.value ?? ""
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {typeText === "Doubles" && (
                                                                            <div className="col-sm-3">
                                                                                <img src={getPlayerImage2(rhsPlayer)} alt="" className="player-image img-responsive img-circle img-user margin-t5"/>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions">
                                                <div className="row">
                                                    <div className="col-lg-12 text-center">
                                                        { !isWinnerdeclared && (
                                                            <button type="button" className="btn btn-brand d-inline-block" onClick={saveDraw}>Save</button>
                                                        )}
                                                        <button type="button" className="btn btn-secondary margin-l10" onClick={() => setRefetchData(true)}> Cancel </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}

                                {/* OTHER ROUNDS */}
                                {drawRounds.map(round => {
                                    if (selectedRound.round !== round.round) return null;
                                    const totalPlayers = round.matches.length * 2;
                                    return (
                                        <div className="kt-portlet kt-portlet--mobile tab-content margin-t10" key={round.round}>
                                            <div className="pnl-round" id={`round${selectedRound.round}` }>
                                            <div className="kt-portlet__head">
                                                <div className="kt-portlet__head-label">
                                                    <h3 className="kt-portlet__head-title">
                                                        {selectedRound.roundName}
                                                    </h3>
                                                </div>
                                                {drawRounds?.length > 0 && (
                                                    <div className="kt-portlet__head-toolbar">
                                                        <div className="kt-widget__button margin-r5">
                                                            <span className="btn btn-label-brand btn-sm">
                                                                Total {typeText}s : <b>{" "}{totalPlayers}</b>
                                                            </span>
                                                        </div>
                                                        </div>
                                                    )
                                                }
                                                {!isFinalWinnerDeclared && (
                                                    <button
                                                        type="button"
                                                        id={`btnRefreshHandicap${round.round}`}
                                                        name={`btnRefreshHandicap${round.round}`}
                                                        className="btn btn-success btn-icon-sm text-white d-inline margin-lr0 btn-sm"
                                                        onClick={() => refreshHandicap(round.round)}
                                                    >
                                                        Refresh Handicap
                                                    </button>
                                                )}
                                                </div>
                                                </div>
                                            <div className="kt-portlet__body">
                                                {round.matches.map((match, index) => {
                                                    // Resolve actual players if IDs are present
                                                    const lhsPlayer = match.lhsPlayer && match.lhsPlayer !== ""
                                                        ? registeredPlayers.find(p => p.ID === match.lhsPlayer)
                                                        : null;
                                                    const rhsPlayer = match.rhsPlayer && match.rhsPlayer !== ""
                                                        ? registeredPlayers.find(p => p.ID === match.rhsPlayer)
                                                        : null;

                                                    const lhsName  = lhsPlayer ? getPlayerName(lhsPlayer) : "TBA";
                                                    const rhsName  = rhsPlayer  ? getPlayerName(rhsPlayer) : "TBA";

                                                    const lhsImg1  = lhsPlayer ? getPlayerImage1(lhsPlayer) : DEFAULT_USER_PHOTO;
                                                    const lhsImg2  = lhsPlayer ? getPlayerImage2(lhsPlayer) : DEFAULT_USER_PHOTO;
                                                    const rhsImg1  = rhsPlayer ? getPlayerImage1(rhsPlayer) : DEFAULT_USER_PHOTO;
                                                    const rhsImg2  = rhsPlayer ? getPlayerImage2(rhsPlayer) : DEFAULT_USER_PHOTO;

                                                    return (
                                                        <div className="card panel-match margin-b20" key={index}>
                                                            {/* CARD HEADER */}
                                                            <div className="card-header" style={{ height: 36 }}>
                                                                <div className="card-title w-100">
                                                                    <div className="row w-100">
                                                                        <div className="col-5">
                                                                            <h6><strong>Match {match.matchNo}</strong></h6>
                                                                        </div>
                                                                        <div className="col-2 text-center">
                                                                            <h6><strong>Group {match.groupNo}</strong></h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* CARD BODY */}
                                                            <div className="card-body" style={{ minHeight: 115 }}>
                                                                <div className="row align-items-center">

                                                                    {/* LHS PLAYER */}
                                                                    <div className="col-sm-5">
                                                                        <div className="row">
                                                                            <div className="col-sm-3">
                                                                                <img
                                                                                    src={lhsImg1}
                                                                                    alt=""
                                                                                    className="player-image img-responsive img-circle img-user margin-t5"
                                                                                />
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <div className="form-group margin-b0">
                                                                                    <label className="col-form-label padding-t0">
                                                                                        {typeText} 1
                                                                                    </label>
                                                                                    <h4 className={`font-16 margin-t10`}>
                                                                                        {lhsName}
                                                                                    </h4>
                                                                                </div>
                                                                            </div>
                                                                            {typeText === "Doubles" && (
                                                                                <div className="col-sm-3">
                                                                                    <img
                                                                                        src={lhsImg2}
                                                                                        alt=""
                                                                                        className="player-image img-responsive img-circle img-user margin-t5"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* VS */}
                                                                    <div className="col-sm-2 text-center">
                                                                        <img
                                                                            src={VS_IMAGE}
                                                                            alt="vs"
                                                                            style={{ width: 85, height: 85 }}
                                                                        />
                                                                    </div>

                                                                    {/* RHS PLAYER */}
                                                                    <div className="col-sm-5">
                                                                        <div className="row">
                                                                            <div className="col-sm-3">
                                                                                <img
                                                                                    src={rhsImg1}
                                                                                    alt=""
                                                                                    className="player-image img-responsive img-circle img-user margin-t5"
                                                                                />
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <div className="form-group margin-b0">
                                                                                    <label className="col-form-label padding-t0">
                                                                                        {typeText} 2
                                                                                    </label>
                                                                                    <h4 className={`font-16 margin-t10`}>
                                                                                        {rhsName}
                                                                                    </h4>
                                                                                </div> 
                                                                            </div>
                                                                            {typeText === "Doubles" && (
                                                                                <div className="col-sm-3">
                                                                                    <img
                                                                                        src={rhsImg2}
                                                                                        alt=""
                                                                                        className="player-image img-responsive img-circle img-user margin-t5"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>
            </MatchPlayList>
        </>
    );
};

export default MatchPlayDraw;